import { render, staticRenderFns } from "./ServiceHelp.vue?vue&type=template&id=59dcec1e&"
import script from "./ServiceHelp.vue?vue&type=script&lang=js&"
export * from "./ServiceHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59dcec1e')) {
      api.createRecord('59dcec1e', component.options)
    } else {
      api.reload('59dcec1e', component.options)
    }
    module.hot.accept("./ServiceHelp.vue?vue&type=template&id=59dcec1e&", function () {
      api.rerender('59dcec1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2T2IinIkhZz1y/JS/comp/ServiceHelp.vue"
export default component.exports